module.exports = __webpack_public_path__ + "img/icon_st05.d9a97793.png";